import { addRoute } from "../shared/router.js";
import reddit from "./page.vue";

addRoute("/reddit", reddit);
